const getFocusedElement = (rootState) => rootState.ws.view.focusedElement;

export default getFocusedElement;
